import type { ReportRange } from "./windows.js";
import { REPORT_RANGES, rangeLabel } from "./windows.js";

export function ReportRangeSelector({
  value,
  onChange,
}: {
  value: ReportRange;
  onChange: (value: ReportRange) => void;
}) {
  return (
    <div className="inline-flex max-w-full flex-nowrap overflow-x-auto rounded-full bg-gray-100 p-0.5 text-xs font-medium dark:bg-gray-800">
      {REPORT_RANGES.map((n) => (
        <button
          key={String(n)}
          type="button"
          onClick={() => onChange(n)}
          className={[
            "min-h-[44px] rounded-full px-3 transition-all sm:min-h-0 sm:py-1",
            value === n
              ? "bg-(--accent) text-(--accent-contrast) shadow-sm"
              : "text-gray-500 hover:text-gray-700 dark:text-gray-300",
          ].join(" ")}
          aria-pressed={value === n}
        >
          {rangeLabel(n)}
        </button>
      ))}
    </div>
  );
}
